import React from 'react';

const NewsSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 1024 1024"
      strokeWidth="1.5"
      stroke="currentColor"
      transform="scale(1,-1)"
      {...props}
    >
      <path d="M848 832h-672c-50.005 0-90.667-38.272-90.667-85.333v-597.333c0-47.061 40.661-85.333 90.667-85.333h672c50.005 0 90.667 38.272 90.667 85.333v597.333c0 47.061-40.661 85.333-90.667 85.333zM848 149.333h-672c-2.432 0-4.096 0.683-4.821 0.683-0.299 0-0.469-0.085-0.512-0.341l-0.512 595.029c0.299 0.427 2.219 1.963 5.845 1.963h672c3.371-0.043 5.205-1.195 5.333-0.341l0.512-595.029c-0.299-0.427-2.219-1.963-5.845-1.963zM256 661.333h256v-256h-256zM554.667 320h-298.667v-85.333h512v85.333h-170.667zM597.333 490.667h170.667v-85.333h-170.667zM597.333 661.333h170.667v-85.333h-170.667z"/>
    </svg>
  );
};

export { NewsSVG };